
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"
import { useRouter } from "next/router"

import SEO from "@/meta/SEO"
import { getHelpCenterArticleProps } from "@/organisms/HelpCenterArticle/functions/getHelpCenterArticleProps"
import HelpCenterArticle from "@/organisms/HelpCenterArticle/HelpCenterArticle"
import Help from "@/templates/Help/Help"

function SignInAndSignUp() {
  const { pathname } = useRouter()

  const sectionsList = [
    ["do_i_have_to_have_account_to_use_fansi", `${pathname}?auth`],
    ["i_lost_account_password"],
  ]

  const props = getHelpCenterArticleProps(
    "helpSignInAndSignUp",
    "sign_in_and_sign_up",
    sectionsList
  )

  return (
    <>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <HelpCenterArticle {...props} />
    </>
  )
}
SignInAndSignUp.Layout = Help
export default SignInAndSignUp


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/signin-and-signup',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  